import React from "react"
import { Button } from "react-bootstrap"
import { useNotificationContext } from "../contextProviders/notificationContext"

export function TestNotifications(props){
  const displayNotif = useNotificationContext()

  
  return (
    <div style={{width:'100%'}}>
      <Button variant="info" onClick={()=>displayNotif('success', 'button press worked')}>
        Test Notifications
      </Button>
      <Button variant="danger" onClick={()=>displayNotif('danger', 'button press worked but now it\'s red')}>
        Test Notifications but Red
      </Button>
    </div>
  )
}